
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[language]/rudraksha-diksha",
      function () {
        return require("private-next-pages/[region]/[language]/rudraksha-diksha/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[language]/rudraksha-diksha"])
      });
    }
  